{
  "carrierLabel": "Entreprise transporteur",
  "searchPlaceholder": "Rechercher par nom",
  "selectAsCarrier": "Sélectionner \"{name}\" comme transporteur",
  "typeToSearch": "Tapez pour rechercher une entreprise"
}
